import { MenuBar } from "components/layout/MenuBar";
import Nav from "components/layout/Nav";
import React, { useEffect, useMemo, useState } from "react";
import { useSelector, useDispatch } from "react-redux";
import { fetchNotifications, removeNotification } from "../../../Slices/notification.slice";
import { useNavigate } from "react-router-dom";


const Notification = () => {
    const notifications = useSelector((state) => state.notifications);
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const [activeFilter, setActiveFilter] = useState("all");
    const [searchTerm, setSearchTerm] = useState("");

    useEffect(() => {
        dispatch(fetchNotifications());
    }, [dispatch]);

    const handleRemoveNotification = (id) => {
        dispatch(removeNotification(id));
    };

    const ClickNotification = (notif) => {
        if (notif?.url) navigate(notif.url);
        dispatch(removeNotification(notif.id || notif._id));
    }

    const formatTime = (value) => {
        if (!value) return "";
        const date = new Date(value);
        if (Number.isNaN(date.getTime())) return "";
        return date.toLocaleString();
    };

    const getAction = (notif) => (notif?.action || "updated").toLowerCase();

    const counts = useMemo(() => {
        const total = notifications.length;
        const created = notifications.filter((n) => getAction(n) === "created").length;
        const updated = notifications.filter((n) => getAction(n) === "updated").length;
        return { total, created, updated };
    }, [notifications]);

    const filteredNotifications = useMemo(() => {
        const query = searchTerm.trim().toLowerCase();
        return notifications.filter((notif) => {
            const action = getAction(notif);
            if (activeFilter !== "all" && action !== activeFilter) return false;
            if (!query) return true;
            const haystack = [
                notif?.message,
                notif?.entityName,
                notif?.entityType,
                notif?.actorId,
            ]
                .filter(Boolean)
                .join(" ")
                .toLowerCase();
            return haystack.includes(query);
        });
    }, [notifications, activeFilter, searchTerm]);

    return (
        <>
            <Nav />
            <div className="row">
                <MenuBar />
                <main className="notifications-page">
                    <div className="notification-panel">
                        <div className="notification-header">
                            <div>
                                <p className="notification-kicker">Updates</p>
                                <h2 className="notification-title">Notifications</h2>
                                <p className="notification-subtitle">
                                    Editor activity and location updates for your team.
                                </p>
                            </div>
                            <button
                                className="btn-blue"
                                style={{ padding: "8px 14px", borderRadius: "10px" }}
                                onClick={() => dispatch(fetchNotifications())}
                            >
                                Refresh
                            </button>
                        </div>

                        <div className="notification-stats">
                            <div className="stat-card">
                                <p>Total</p>
                                <h3>{counts.total}</h3>
                            </div>
                            <div className="stat-card">
                                <p>Created</p>
                                <h3>{counts.created}</h3>
                            </div>
                            <div className="stat-card">
                                <p>Updated</p>
                                <h3>{counts.updated}</h3>
                            </div>
                        </div>

                        <div className="notification-controls">
                            <div className="notification-filters">
                                {["all", "created", "updated"].map((filter) => (
                                    <button
                                        key={filter}
                                        className={`filter-pill ${activeFilter === filter ? "active" : ""}`}
                                        onClick={() => setActiveFilter(filter)}
                                    >
                                        {filter === "all" ? "All" : filter.charAt(0).toUpperCase() + filter.slice(1)}
                                    </button>
                                ))}
                            </div>
                            <div className="notification-search">
                                <input
                                    type="text"
                                    placeholder="Search by editor, location, or message"
                                    value={searchTerm}
                                    onChange={(e) => setSearchTerm(e.target.value)}
                                />
                            </div>
                        </div>

                        {filteredNotifications.length === 0 && (
                            <div className="notification-empty">
                                <p>No notifications found.</p>
                            </div>
                        )}

                        <div className="notification-list">
                            {filteredNotifications.map((notif) => {
                                const action = getAction(notif);
                                return (
                                    <div
                                        key={notif.id || notif._id}
                                        className={`notification-card action-${action}`}
                                        onClick={() => ClickNotification(notif)}
                                        role="button"
                                        tabIndex={0}
                                        onKeyDown={(e) => {
                                            if (e.key === "Enter") ClickNotification(notif);
                                        }}
                                    >
                                        <div className="notification-indicator" />
                                        <div className="notification-content">
                                            <div className="notification-row">
                                                <h4 className="notification-message">{notif.message}</h4>
                                                <span className="notification-time">{formatTime(notif.createdAt)}</span>
                                            </div>
                                            <div className="notification-meta">
                                                <span className="meta-pill">{(notif.entityType || "Location").toUpperCase()}</span>
                                                <span className="meta-muted">{notif.entityName || "Untitled"}</span>
                                                <span className="meta-muted">By: {notif.actorId || "Editor"}</span>
                                                <span className="meta-muted">Action: {action}</span>
                                            </div>
                                        </div>
                                        <div className="notification-actions">
                                            <button
                                                className="btn-white"
                                                onClick={(e) => {
                                                    e.stopPropagation();
                                                    handleRemoveNotification(notif.id || notif._id);
                                                }}
                                            >
                                                Close
                                            </button>
                                        </div>
                                    </div>
                                );
                            })}
                        </div>
                    </div>
                </main>
            </div>
        </>
    )
}

export default Notification;
